import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { ActiveInactive } from 'src/api';
import { useConsumerById } from 'src/hooks/consumer';
import { useCurrentUserVerifier } from 'src/hooks/verifier';
import { SxProp } from 'src/types/mui';

type FreezeAccountBlockProps = {
  employeeId: Nullable<string>;
};

export const FreezeAccountBlock: React.FC<FreezeAccountBlockProps> = ({ employeeId }) => {
  const { isCommercialVerifier } = useCurrentUserVerifier();

  const { consumer } = useConsumerById(employeeId);

  return (
    <React.Fragment>
      {isCommercialVerifier && consumer?.freeze === ActiveInactive.Active && (
        <Alert variant="outlined" sx={alertStyles} severity="error">
          <AlertTitle>Employee Account is frozen</AlertTitle>
          This employee is not accepting verification requests from commercial verifiers.
        </Alert>
      )}
    </React.Fragment>
  );
};

const alertStyles: SxProp = theme => ({
  mt: 3,
  color: theme.palette.alert?.error?.dark,
  borderColor: theme.palette.error.main,
});
